import { styled } from '@stitches/configed';
import Layout from './Layout';
// import Button from '../Common/Button'
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Form, { Field } from '../Common/Form';
import { ClockOutLineIcon } from '../Common/Icons/ClockIconOutLine';
import QuestionlinedIcon from '../Common/Icons/QuestionLineIcon';
import Input from '../Common/Input';
import ModalDialog from '../Common/Modal/ModalDialog';

export const Title = styled('h4', {
  uTextSize: 'lg',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: '1rem',
});

export const SubmitButton = styled(Button, {
  width: '100%',
  height: 52,
});
export const ForgotPasswordText = styled('div', {
  marginTop: 32,
  color: '$link',
  cursor: 'pointer',
});

export const LinkStyled = styled('span', {
  color: '$link',
  cursor: 'pointer',
});

type Props = {
  onSubmit: (value: { email: string }) => void;
  isSubmiting: boolean;
  errorMessage?: string;
  clearMessage?: () => void;
  showLinkForgotPassword?: boolean;
  heading?: string;

  isAccInactive: boolean;
  isError: boolean;
  closeErrorModal: () => void;
  closeInactiveModal: () => void;
};
export default function PreLogin({
  onSubmit,
  isSubmiting,
  errorMessage,
  clearMessage,
  showLinkForgotPassword,
  heading,
  isAccInactive,
  isError,
  closeInactiveModal,
  closeErrorModal
}: Props) {
  const navigate = useNavigate();

  const onFinish = (value: any) => {
    onSubmit(value);
  };
  return (
    <Layout>
      <ModalDialog
        visible={isError ? true : false}
        type="warning"
        icon={<QuestionlinedIcon />}
        heading="Bạn chưa phải là đối tác nhà hàng của YouGo"
        message="Tài khoản này chưa được đăng ký. Bạn có muốn trở thành đối tác nhà hàng của YouGo?"
        confirm={true}
        confirmText="Đăng Ký"
        onClose={closeErrorModal}
        onConfirm={closeErrorModal}
      />

      <ModalDialog
        visible={isAccInactive ? true : false}
        type="warning"
        icon={<ClockOutLineIcon />}
        heading={'Tài khoản đang được hoàn thiện hồ sơ đăng ký'}
        message={
          'Tài khoản của bạn đang hoàn thiện hồ sơ đăng ký trở thành đối tác nhà hàng của YouGo. '
        }
        subMessage={
          'Vui lòng theo dõi hộp thư mer***@y***.com để nhận cập nhật mới nhất.YouGo xin cảm ơn!'
        }
        onClose={closeInactiveModal}
        onConfirm={closeInactiveModal}
        confirmText="Tôi đã hiểu"
      />

      <Form layout="vertical" onFinish={onFinish} validateTrigger="onSubmit">
        <Title>Đăng nhập tài khoản</Title>
        <Field
          hidden
          name="firebaseToken"
          initialValue={localStorage.getItem('firebaseToken') || uuidv4()}
        >
          <Input />
        </Field>
        <Field
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Vui lòng nhập email!' },
            { type: 'email', message: 'Email sai định dạng' },
          ]}
        >
          <Input placeholder="Nhập email" />
        </Field>

        <Field>
          <Button type="primary" htmlType="submit" block loading={isSubmiting}>
            Tiếp tục
          </Button>
        </Field>

        <Field>
          <div style={{ display: 'flex', marginTop: 10 }}>
            {showLinkForgotPassword && (
              <LinkStyled onClick={() => navigate('/forgot-password')}>
                Quên mật khẩu đăng nhập
              </LinkStyled>
            )}
          </div>
        </Field>
      </Form>
    </Layout>
  );
}
